/* VORELL v3 runtime — Shopify port of v3/src/vorell3.js (theme asset v3-vorell3.js).
   Same DOM/classes/behaviour as the approved v3 preview; data from Shopify:
   - cart = Shopify AJAX Cart API (window.Shopify.routes.root + cart/add.js, cart.js, cart/change.js); badge = item_count
   - drawer totals/discounts come from cart.js (multi-buy = native automatic discounts, codes = cart-level applications)
   - free shipping estimate on the discounted physical subtotal (>= 1.500 TL free, else 149,90 TL; gift cards excluded)
   - checkout -> routes.root + 'checkout' (same tab)
   - Glow Club -> POST routes.root + 'contact' (form_type=customer, tags newsletter,glow-club)
   - wholesale form -> native Shopify contact form ({% form 'contact' %}), validated here, submitted without AJAX
   window.VP / VL / VW / VHERO / VCART are rendered by snippets/v3-vp-<lang>.liquid.
   Restored old-theme features (v3_restore.py, 2026-11-01): predictive search (search/suggest.json), wishlist (localStorage
   'vorell_wishlist', as assets/vorell-wishlist.js), back-in-stock (Klaviyo client API, as assets/vorell-bis.js), gift wrap and
   gift-card recipient line-item properties, buy-it-now sync, order note (cart/update.js), /cart shipping estimator, recently viewed,
   sold-out states, Glow Club fields/timing as snippets/vorell-popup.liquid. window.VR = strings, window.VPX = dynamic PDP data. */
(function () {
  "use strict";
  var MB = { scope: "line", tiers: [{ q: 1, off: 0 }, { q: 2, off: 15 }, { q: 3, off: 25 }] };
  var FREE = window.VFREE || 1500, SHIP = 149.9;
  var VP = window.VP || {}, L = window.VL || {}, LANG = window.VLANG || "tr", VW = window.VW || {}, RTL = document.documentElement.dir === "rtl";
  var R = window.VR || {};
  if (window.VPX) for (var vk in window.VPX) if (!VP[vk]) VP[vk] = window.VPX[vk];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var params = new URLSearchParams(location.search);
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(h) { var t = document.createElement("template"); t.innerHTML = h.trim(); return t.content.firstChild; }
  function fmt(n) {
    var r = Math.round(n * 100) / 100, whole = Math.abs(r % 1) < 1e-9;
    var s = r.toLocaleString("tr-TR", { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    return RTL ? "⁦" + s + " TL⁩" : s + " TL";
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M12 21s-6.7-4.3-9.3-8.2C.9 10.1 1.6 6.6 4.5 5.4c2-.8 4 .1 5 1.7 1-1.6 3-2.5 5-1.7 2.9 1.2 3.6 4.7 1.8 7.4C18.7 16.7 12 21 12 21z"/></svg>';
  function offFor(n) { var o = 0; MB.tiers.forEach(function (t) { if (n >= t.q) o = t.off; }); return o; }

  // ---------------- cart state (Shopify AJAX Cart API) ----------------
  var cart = window.VCART || { items: [], item_count: 0, total_price: 0, original_total_price: 0, total_discount: 0, discount_codes: [], cart_level_discount_applications: [] };
  var busy = false, seq = 0, cartErr = "";
  function api(path, body) {
    var o = body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body), credentials: "same-origin" }
                 : { headers: { Accept: "application/json" }, credentials: "same-origin" };
    return fetch(ROOT + path, o).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || "cart"); e.j = j; throw e; } return j; }); });
  }
  // QA fix: every cart response gets a sequence number; a late cart.js (DOMContentLoaded / pageshow) can no longer overwrite newer state
  function refresh() { var my = ++seq; return api("cart.js").then(function (c) { if (my === seq) { cart = c; render(); } return c; }); }
  function setBusy(b) {
    busy = b;
    if (drawer) { drawer.classList.toggle("busy", b); qa("[data-i]", drawer).forEach(function (x) { x.disabled = b; }); }
  }
  function errText(e) { return (e && e.j && (e.j.description || e.j.message)) || L.cartErr || ""; }
  function calc() {
    var sub = 0, mb = 0, lines = [], phys = 0;
    (cart.items || []).forEach(function (it, i) {
      var p = VP[it.handle] || { name: it.product_title, url: it.url, img: it.image };
      var gift = !!it.gift_card, set = !!p.set;
      var unit = it.original_price / 100, full = it.original_line_price / 100;
      var lineDisc = 0; (it.line_level_discount_allocations || []).forEach(function (a) { lineDisc += a.amount; });
      lineDisc = lineDisc / 100;
      var tot = full - lineDisc, off = lineDisc > 0 && full > 0 ? Math.round(lineDisc / full * 100) : 0;
      sub += full; mb += lineDisc;
      if (!gift && it.requires_shipping !== false) phys += it.line_price / 100;   // line_price = after line + cart-level (code) discounts
      lines.push({ it: it, i: i, p: p, gift: gift, set: set, q: it.quantity, unit: unit, off: off, full: full, tot: tot });
    });
    var codes = (cart.cart_level_discount_applications || []).map(function (a) { return { title: a.title, amt: a.total_allocated_amount / 100 }; });
    var after = (cart.total_price || 0) / 100, ship = phys === 0 ? 0 : (phys >= FREE ? 0 : SHIP);
    return { lines: lines, sub: sub, mb: mb, codes: codes, after: after, phys: phys, ship: ship, total: after + ship,
             left: phys === 0 ? 0 : Math.max(0, FREE - phys), gifts: lines.length && lines.every(function (x) { return x.gift; }) };
  }
  function lineQty(v) { var n = 0; (cart.items || []).forEach(function (it) { if (it.variant_id === +v) n += it.quantity; }); return n; }
  function announce(t) { var r = q("[data-live]"); if (!r || !t) return; r.textContent = ""; setTimeout(function () { r.textContent = t; }, 60); }
  function add(h, v, n, props) {
    var p = VP[h]; if (!p || busy) return;
    v = v || p.vid; n = Math.min(n || 1, 20 - lineQty(v));
    if (n <= 0) { openCart(); return; }
    setBusy(true); cartErr = "";
    var item = { id: +v, quantity: n };
    if (props && Object.keys(props).length) item.properties = props;   // line-item properties (gift wrap / gift card recipient), as the old product form
    // QA fix: a 422 from add.js (sold out / inventory limit) is shown in the drawer instead of being swallowed
    api("cart/add.js", { items: [item] })
      .then(function () { announce(R.added); return refresh(); }, function (e) { cartErr = errText(e); announce(cartErr); return refresh(); })
      .then(function () { setBusy(false); render(); openCart(); }, function () { setBusy(false); render(); openCart(); });
  }
  function addVariant(vid, n) {   // wishlist drawer: products without a VP entry
    if (busy) return Promise.resolve();
    setBusy(true); cartErr = "";
    return api("cart/add.js", { items: [{ id: +vid, quantity: n || 1 }] })
      .then(function () { announce(R.added); return refresh(); }, function (e) { cartErr = errText(e); return refresh(); })
      .then(function () { setBusy(false); render(); openCart(); }, function () { setBusy(false); render(); openCart(); });
  }
  function setQty(i, n) {
    var it = cart.items[i]; if (!it || busy) return;
    setBusy(true); cartErr = "";
    var my = ++seq;
    api("cart/change.js", { id: it.key, quantity: n <= 0 ? 0 : Math.min(20, n) })
      .then(function (c) { if (my === seq) { cart = c; } }, function (e) { cartErr = errText(e); return refresh(); })
      .then(function () { setBusy(false); render(); }, function () { setBusy(false); render(); });
  }

  // ---------------- cart drawer ----------------
  var drawer;
  function buildDrawer() {
    drawer = el('<div class="cd" role="dialog" aria-modal="true" aria-label="' + L.cart + '" hidden><div class="cd-scrim" data-cd-close></div>' +
      '<aside class="cd-panel"><header class="cd-hd"><h2>' + L.cart + '</h2><button type="button" class="cd-x" data-cd-close aria-label="' + L.close + '">×</button></header>' +
      '<div class="cd-ship"><p class="cd-ship-t"></p><div class="cd-bar"><span></span></div></div>' +
      '<div class="cd-lines"></div><div class="cd-notebox" hidden><details><summary>' + (R.noteAdd || "") + '</summary>' +
      '<textarea maxlength="500" placeholder="' + esc(R.notePh || "") + '" aria-label="' + esc(R.note || "") + '"></textarea><span class="cd-note-st" aria-live="polite"></span></details></div>' +
      '<footer class="cd-ft"></footer></aside></div>');
    document.body.appendChild(drawer);
    var ta = q(".cd-notebox textarea", drawer);
    if (ta) ta.addEventListener("input", function () { saveNote(ta.value, q(".cd-note-st", drawer)); });
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-cd-close]")) closeCart();
      var b = e.target.closest("[data-i]"); if (!b) return;
      var i = +b.getAttribute("data-i"), d = +b.getAttribute("data-d"), it = cart.items[i]; if (!it) return;
      setQty(i, d === 0 ? 0 : it.quantity + d);
    });
  }
  function render() {
    var c = calc(), n = cart.item_count || 0, empty = !(cart.items && cart.items.length);
    qa("[data-cart-count]").forEach(function (e) { e.textContent = n; e.hidden = n === 0; });
    if (!drawer) return;
    var t = q(".cd-ship-t", drawer), bar = q(".cd-bar span", drawer);
    t.innerHTML = empty ? L.shipInfo : (c.left > 0 ? L.shipLeft.replace("{x}", "<b>" + fmt(c.left) + "</b>") : "<b>" + L.shipFree + "</b>");
    bar.style.width = Math.min(100, (c.phys ? c.phys / FREE : (empty ? 0 : 1)) * 100) + "%";
    var box = q(".cd-lines", drawer);
    box.innerHTML = (cartErr ? '<p class="cd-fine cd-err" role="alert">' + esc(cartErr) + "</p>" : "") +
      (empty ? '<p class="cd-empty">' + L.empty + '</p><a class="btn cd-empty-btn" href="' + L.homeUrl + '#urunler">' + L.shopNow + "</a>" : "");
    c.lines.forEach(function (x) {
      var name = esc(x.p.name) + (x.gift ? " · " + fmt(x.unit) : "");
      box.appendChild(el('<div class="cd-line"><a class="cd-img" href="' + x.p.url + '"><img src="' + x.p.img + '" alt=""></a>' +
        '<div class="cd-mid"><a class="cd-name" href="' + x.p.url + '">' + name + "</a>" + props(x.it) +
        (x.off ? '<span class="cd-badge">' + (L.offFmt || "−{n}%").replace("{n}", x.off) + " · " + (x.q >= 3 ? "3+" : x.q) + " " + L.pcs + "</span>" : (x.gift ? '<span class="cd-note">' + L.giftNoMb + "</span>" : (x.set ? '<span class="cd-note">' + L.setNoMb + "</span>" : (VP[x.it.handle] ? '<span class="cd-note">' + (x.q === 1 ? L.addOneMore : L.addThird) + "</span>" : "")))) +
        '<div class="cd-qty"><button type="button" data-i="' + x.i + '" data-d="-1" aria-label="−"' + (busy ? " disabled" : "") + '>−</button><b>' + x.q + '</b><button type="button" data-i="' + x.i + '" data-d="1" aria-label="+"' + (busy ? " disabled" : "") + '>+</button>' +
        '<button type="button" class="cd-rm" data-i="' + x.i + '" data-d="0"' + (busy ? " disabled" : "") + '>' + L.remove + "</button></div></div>" +
        '<div class="cd-pr">' + (x.off ? "<s>" + fmt(x.full) + "</s>" : "") + "<b>" + fmt(x.tot) + "</b></div></div>"));
    });
    var nb = q(".cd-notebox", drawer); if (nb) { nb.hidden = empty; var nta = q("textarea", nb); if (nta && document.activeElement !== nta) { nta.value = cart.note || ""; if (cart.note) q("details", nb).open = true; } }
    cartPage(c, empty);
    var ft = q(".cd-ft", drawer);
    if (empty) { ft.innerHTML = ""; return; }
    var na = (cart.discount_codes || []).filter(function (d) { return d.applicable === false; })
      .map(function (d) { return '<p class="cd-fine">' + (L.codeNA || "{code}").replace("{code}", esc(d.code)) + "</p>"; }).join("");
    ft.innerHTML = '<dl class="cd-sum"><dt>' + L.subtotal + "</dt><dd>" + fmt(c.sub) + "</dd>" +
      (c.mb ? '<dt class="cd-disc">' + L.mbDiscount + '</dt><dd class="cd-disc">−' + fmt(c.mb) + "</dd>" : "") +
      c.codes.map(function (d) { return '<dt class="cd-disc">' + esc(d.title) + '</dt><dd class="cd-disc">−' + fmt(d.amt) + "</dd>"; }).join("") +
      "<dt>" + L.shipping + "</dt><dd>" + (c.ship ? fmt(c.ship) : L.free) + "</dd>" +
      '<dt class="cd-tot">' + L.total + '</dt><dd class="cd-tot">' + fmt(c.total) + "</dd></dl>" +
      '<a class="btn cd-go" href="' + ROOT + 'checkout">' + L.checkout + "</a>" +
      '<p class="cd-fine">' + L.previewNote + "</p>" + na;
  }
  function props(it) {
    var o = it.properties || {}, out = "";
    Object.keys(o).forEach(function (k) { var v = o[k]; if (k.charAt(0) === "_" || v == null || v === "") return; out += '<span class="cd-props">' + esc(k) + ": " + esc(v) + "</span>"; });
    return out;
  }
  var noteT = 0;
  function saveNote(v, st) {
    clearTimeout(noteT);
    noteT = setTimeout(function () {
      api("cart/update.js", { note: v }).then(function (c) { cart.note = c.note; if (st) { st.textContent = R.noteSaved || ""; setTimeout(function () { st.textContent = ""; }, 2000); } }, function () {});
    }, 600);
  }
  // /cart page: free-shipping bar + shipping line follow cart.js like the drawer
  function cartPage(c, empty) {
    var bar = q("[data-cartship]"); if (!bar) return;
    q(".cd-ship-t", bar).innerHTML = empty || !c.phys ? L.shipInfo : (c.left > 0 ? L.shipLeft.replace("{x}", "<b>" + fmt(c.left) + "</b>") : "<b>" + L.shipFree + "</b>");
    q(".cd-bar span", bar).style.width = Math.min(100, (c.phys ? c.phys / FREE : 0) * 100) + "%";
    var sh = q("[data-cartship-amt]"), tt = q("[data-cartship-tot]");
    if (sh) sh.textContent = c.ship ? fmt(c.ship) : L.free;
    if (tt) tt.textContent = fmt(c.total);
  }
  function openCart() { if (!drawer) return; drawer.hidden = false; document.documentElement.classList.add("lock"); }
  function closeCart() { if (!drawer) return; drawer.hidden = true; document.documentElement.classList.remove("lock"); if (cartErr) { cartErr = ""; render(); } }

  // ---------------- hero video ----------------
  function hero() {
    qa("video[data-hero]").forEach(function (v) {
      var k = window.matchMedia("(max-width: 767px)").matches ? "mobile" : "desktop", H = (window.VHERO || {})[k]; if (!H) return;
      v.poster = H.poster;
      // mp4 (H.264 Main, yuv420p) first: iOS/Android always play it; webm as fallback
      v.innerHTML = '<source src="' + H.mp4 + '" type="video/mp4"><source src="' + H.webm + '" type="video/webm">';
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute("playsinline", "");
      if (!params.has("still")) { v.autoplay = true; v.load(); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    });
  }

  // ---------------- product page ----------------
  function pdp() {
    var root = q("[data-pdp]"); if (!root) return;
    var h = root.getAttribute("data-pdp"), p = VP[h]; if (!p) return;
    var main = q("[data-gal-main]", root);
    qa(".v-thumb", root).forEach(function (b) {
      b.addEventListener("click", function () {
        main.src = b.getAttribute("data-src"); var ti = q("img", b); if (ti && ti.alt) main.alt = ti.alt;
        qa(".v-thumb", root).forEach(function (x) { x.classList.remove("on"); }); b.classList.add("on");
      });
    });
    qa("[role=tab]", root).forEach(function (t) {
      t.addEventListener("click", function () {
        qa("[role=tab]", root).forEach(function (x) { x.setAttribute("aria-selected", "false"); });
        qa("[role=tabpanel]", root).forEach(function (x) { x.hidden = true; });
        t.setAttribute("aria-selected", "true"); q("#" + t.getAttribute("aria-controls")).hidden = false;
      });
    });
    var btn = q("[data-buy]", root), sticky = q("[data-sticky]"), mb = q("[data-mb]", root);
    var state = { n: 1, vid: p.vid, price: p.price, cmp: 0, avail: p.avail !== false };
    var nomb = !!(p.gift || p.set || p.nomb);
    // a selected variant from Liquid (?variant= deep link / first available) wins over VP's first variant
    var sel = q("[data-variant].on", root);
    if (sel) { state.vid = +sel.getAttribute("data-variant"); state.price = +sel.getAttribute("data-price"); state.cmp = +(sel.getAttribute("data-cmp") || 0); state.avail = sel.getAttribute("data-avail") !== "false"; }
    function total() { return state.price * state.n * (1 - (nomb ? 0 : offFor(state.n)) / 100); }
    function label() { return L.addToCart + " · " + fmt(total()); }
    var payF = q(".v-pay", root), payId = q("[data-pay-id]", root), payQ = q("[data-pay-q]", root), bisB = q("[data-bis]", root);
    function paint() {
      btn.textContent = state.avail ? label() : (R.soldOut || "");
      btn.disabled = !state.avail;
      if (sticky) {
        var sb = q("[data-sticky-btn]", sticky); sb.textContent = state.avail ? L.addToCart : (R.soldOut || ""); sb.disabled = !state.avail;
        q("[data-sticky-pr]", sticky).textContent = fmt(total()); q("[data-sticky-q]", sticky).textContent = state.n + " " + L.pcs;
      }
      if (payId) payId.value = state.vid;
      if (payQ) payQ.value = state.n;
      if (payF) payF.classList.toggle("is-off", !state.avail);
      if (bisB) bisB.hidden = state.avail;
      var ship = q("[data-ship]", root); var left = FREE - total();
      if (ship && p.gift) ship.textContent = L.giftShip;
      else if (ship) ship.innerHTML = (left > 0 ? L.shipLeft.replace("{x}", "<b>" + fmt(left) + "</b>") : "<b>" + L.shipFree + "</b>") + " · " + L.dispatch;
    }
    function paintCmp() {
      var w = q("[data-f=cmp]", root); if (!w) return;
      var on = state.cmp > state.price; w.hidden = !on;
      if (on) { q("[data-f=cmp-s]", w).textContent = fmt(state.cmp); q("[data-f=cmp-o]", w).textContent = (L.offFmt || "−{n}%").replace("{n}", Math.round((state.cmp - state.price) / state.cmp * 100)); }
    }
    function paintMb() {   // multi-buy cards follow the selected variant's price (only differs once a product gets several variants)
      if (!mb) return; var cards = qa(".v-mb-card", mb), pr = state.price; if (cards.length < 3) return;
      var unit = function (el, v) { el.textContent = el.textContent.replace(/\u2066?[\d.,]+ TL\u2069?/, fmt(v)); };
      q(".v-mb-now", cards[0]).textContent = fmt(pr);
      q(".v-mb-was", cards[1]).textContent = fmt(pr * 2); q(".v-mb-now", cards[1]).textContent = fmt(pr * 2 * 0.85); unit(q(".v-mb-unit", cards[1]), pr * 0.85);
      unit(q(".v-mb-unit", cards[2]), pr * 0.75);
      var n3 = state.n >= 3 ? state.n : 3; q(".v-mb-was", cards[2]).textContent = fmt(pr * n3); q(".v-mb-now", cards[2]).textContent = fmt(pr * n3 * 0.75);
    }
    if (mb) {
      var cards = qa(".v-mb-card", mb), stepper = q("[data-qty]", root);
      var updateThree = function () {
        var c = cards[2], full = state.price * state.n, tot = full * 0.75;
        q(".v-mb-was", c).textContent = fmt(full); q(".v-mb-now", c).textContent = fmt(tot); q(".v-mb-q", c).textContent = state.n === 3 ? "3+ " + L.pcs : state.n + " " + L.pcs;
      };
      var pick = function (i) {
        cards.forEach(function (c, j) { c.classList.toggle("on", j === i); c.setAttribute("aria-checked", String(j === i)); });
        state.n = i === 2 ? Math.max(3, state.n3 || 3) : i + 1; if (i === 2) state.n3 = state.n;
        stepper.hidden = i !== 2; q("[data-qty-n]", stepper).textContent = state.n; paint();
      };
      cards.forEach(function (c, i) { c.addEventListener("click", function () { pick(i); }); });
      q("[data-qty-minus]", stepper).addEventListener("click", function () { state.n = Math.max(3, state.n - 1); state.n3 = state.n; q("[data-qty-n]", stepper).textContent = state.n; updateThree(); paint(); });
      q("[data-qty-plus]", stepper).addEventListener("click", function () { state.n = Math.min(20, state.n + 1); state.n3 = state.n; q("[data-qty-n]", stepper).textContent = state.n; updateThree(); paint(); });
    }
    var simple = q("[data-qty-simple]", root);
    if (simple) {
      var setN = function (n) { state.n = Math.max(1, Math.min(20, n)); q("[data-qty-n]", simple).textContent = state.n; paint(); };
      q("[data-qty-minus]", simple).addEventListener("click", function () { setN(state.n - 1); });
      q("[data-qty-plus]", simple).addEventListener("click", function () { setN(state.n + 1); });
    }
    qa("[data-variant]", root).forEach(function (b) {
      b.addEventListener("click", function () {
        qa("[data-variant]", root).forEach(function (x) { x.classList.remove("on"); x.setAttribute("aria-checked", "false"); });
        b.classList.add("on"); b.setAttribute("aria-checked", "true");
        state.vid = +b.getAttribute("data-variant"); state.price = +b.getAttribute("data-price");
        state.cmp = +(b.getAttribute("data-cmp") || 0); state.avail = b.getAttribute("data-avail") !== "false";
        qa("[data-f=price]", root).forEach(function (e) { e.textContent = fmt(state.price); });
        // keep ?variant= in the URL like the old variant picker (feeds, emails and shares land on the same amount)
        try { var u = new URL(location.href); u.searchParams.set("variant", state.vid); history.replaceState(history.state, "", u.toString()); } catch (x) {}
        paintCmp(); paintMb(); paint();
      });
    });
    // gift wrap (old snippets/vorell-gift-options: properties[Hediye paketleme]=Evet, properties[Hediye notu])
    var gw = q("[data-gift-wrap]", root), gn = q("[data-gift-note]", root), gt = q("[data-gift-text]", root);
    if (gw && gn) gw.addEventListener("change", function () { gn.hidden = !gw.checked; });
    // gift card recipient (old buy-buttons gift-card-recipient: Shopify's own property names)
    var gc = q("[data-gcr-on]", root), gf = q("[data-gcr-fields]", root);
    if (gc && gf) gc.addEventListener("change", function () {
      gf.hidden = !gc.checked; qa("[data-gcr-k]", gf).forEach(function (i) { i.disabled = !gc.checked; });
      var off = q("[data-gcr-k=__shopify_offset]", gf); if (off) off.value = String(new Date().getTimezoneOffset());
    });
    function collect() {
      var o = {};
      if (gw && gw.checked) o["Hediye paketleme"] = gw.value;
      if (gt && gt.value.trim()) o["Hediye notu"] = gt.value.trim();
      if (gc && gc.checked) {
        o["__shopify_send_gift_card_to_recipient"] = "on";
        qa("[data-gcr-k]", gf).forEach(function (i) { var v = (i.value || "").trim(); if (v) o[i.getAttribute("data-gcr-k")] = v; });
      }
      return o;
    }
    function buy() {
      if (!state.avail) return;
      if (gc && gc.checked) {
        var em = q("[data-gcr-k='Recipient email']", gf), er = q(".v-gcr-err", gf);
        var ok = em && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim()); if (er) er.hidden = ok;
        if (!ok) { if (em) em.focus(); return; }
      }
      add(h, state.vid, state.n, collect());
    }
    btn.addEventListener("click", buy);
    if (sticky) {
      q("[data-sticky-btn]", sticky).addEventListener("click", buy);
      var chk = function () { sticky.classList.toggle("show", btn.getBoundingClientRect().bottom < 0); };
      window.addEventListener("scroll", chk, { passive: true }); window.addEventListener("resize", chk); chk();
    }
    // back in stock (old assets/vorell-bis.js: Klaviyo client API, company XQtSp4, same body and revision header)
    if (bisB) {
      var bo = q("[data-bis-open]", bisB), bf = q("[data-bis-form]", bisB), bm = q(".v-bis-msg", bisB);
      bo.addEventListener("click", function () { bf.hidden = !bf.hidden; bo.setAttribute("aria-expanded", String(!bf.hidden)); if (!bf.hidden) q("input", bf).focus(); });
      bf.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = q("input", bf).value.trim();
        function msg(t, cls) { bm.textContent = t; bm.className = "v-bis-msg" + (cls ? " " + cls : ""); }
        if (!email || email.indexOf("@") < 1) { msg(R.bisBadEmail, "err"); return; }
        if (!state.vid) { msg(R.bisNoVar, "err"); return; }
        msg(R.bisSaving);
        var body = { data: { type: "back-in-stock-subscription", attributes: { profile: { data: { type: "profile", attributes: { email: email } } }, channels: ["EMAIL"] },
                             relationships: { variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + state.vid } } } } };
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=XQtSp4", {
          method: "POST", headers: { "Content-Type": "application/json", "revision": "2024-10-15" }, body: JSON.stringify(body)
        }).then(function (r) {
          if (r.status >= 200 && r.status < 300) { msg("✓ " + R.bisOk, "ok"); bf.hidden = true; bo.setAttribute("aria-expanded", "false"); }
          else msg(R.bisErr, "err");
        }).catch(function () { msg(R.bisNet, "err"); });
      });
    }
    recent(h);
    paintCmp(); paint();
  }

  // ---------------- recently viewed (old recently-viewed-products section) ----------------
  function recent(h) {
    var KEY = "vorell_rv", list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { list = []; }
    var show = list.filter(function (x) { return x !== h && VP[x]; }).slice(0, 8);
    list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 12);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    var sec = q("[data-rv]"), strip = sec && q(".v-strip", sec); if (!sec || !strip || !show.length) return;
    strip.innerHTML = show.map(function (x) {
      var p = VP[x];
      return '<article class="pc"><button type="button" class="vorell-wish-heart v-heart" data-wish-handle="' + esc(x) + '" aria-label="' + esc(R.wishAdd || "") + '" aria-pressed="false">' + HEART + "</button>" +
        '<a class="pc-img" href="' + esc(p.url) + '"><img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.name) + '" width="1000" height="1000"></a>' +
        '<div class="pc-body"><h3 class="pc-name"><a href="' + esc(p.url) + '">' + esc(p.name) + '</a></h3><div class="pc-row"><span class="pc-price">' + fmt(p.price) + "</span>" +
        (p.gift ? "" : '<button type="button" class="pc-add" data-add="' + esc(x) + '">' + esc(L.addToCart) + "</button>") + "</div></div></article>";
    }).join("");
    sec.hidden = false; soldOutCards(strip); wish.sync();
  }
  function soldOutCards(scope) {
    qa("[data-add]", scope).forEach(function (b) {
      var p = VP[b.getAttribute("data-add")];
      if (p && p.avail === false) { b.disabled = true; b.textContent = R.soldOut || b.textContent; }
    });
  }

  // ---------------- quick add (cards, sets) ----------------
  function quick() {
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-add]"); if (!b) return;
      e.preventDefault(); if (b.disabled) return;
      var p = VP[b.getAttribute("data-add")]; if (p && p.avail === false) return;
      add(b.getAttribute("data-add"), null, +(b.getAttribute("data-n") || 1));
    });
    qa("[data-cart-open]").forEach(function (b) { b.addEventListener("click", openCart); });
    qa("[data-strip-nav]").forEach(function (b) {
      b.addEventListener("click", function () { var s = q(b.getAttribute("data-strip-nav")); s.scrollBy({ left: (b.dataset.dir === "prev" ? -1 : 1) * (RTL ? -1 : 1) * s.clientWidth * 0.8, behavior: "smooth" }); });
    });
  }

  // ---------------- wishlist (old assets/vorell-wishlist.js: localStorage 'vorell_wishlist', newest first) ----------------
  var wish = (function () {
    var KEY = "vorell_wishlist", wd;
    function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    function has(h) { return get().indexOf(h) > -1; }
    function toggle(h) {
      if (!h) return; var a = get(), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.unshift(h);
      save(a); sync(); if (wd && !wd.hidden) renderW();
    }
    function sync() {
      var n = get().length;
      qa(".vorell-wish-count").forEach(function (e) { e.textContent = n; e.hidden = n === 0; });
      qa(".vorell-wish-heart,.vorell-wish-pdp").forEach(function (b) {
        var on = has(b.getAttribute("data-wish-handle")); b.classList.toggle("is-active", on); b.setAttribute("aria-pressed", on ? "true" : "false");
        var t = on ? (R.wishOn || "") : (R.wishAdd || ""); b.setAttribute("aria-label", t); if (b.classList.contains("vorell-wish-pdp")) b.title = t;
      });
    }
    function build() {
      wd = el('<div class="cd v-wd" role="dialog" aria-modal="true" aria-label="' + esc(R.wish || "") + '" hidden><div class="cd-scrim" data-wd-close></div>' +
        '<aside class="cd-panel"><header class="cd-hd"><h2>' + esc(R.wish || "") + '</h2><button type="button" class="cd-x" data-wd-close aria-label="' + esc(L.close) + '">×</button></header>' +
        '<div class="cd-lines"></div></aside></div>');
      document.body.appendChild(wd);
      wd.addEventListener("click", function (e) {
        if (e.target.closest("[data-wd-close]")) { close(); return; }
        var rm = e.target.closest("[data-wd-rm]"); if (rm) { toggle(rm.getAttribute("data-wd-rm")); return; }
        var ad = e.target.closest("[data-wd-add]");
        if (ad && !ad.disabled) { var h = ad.getAttribute("data-wd-add"), v = ad.getAttribute("data-vid"); close(); if (VP[h] && +VP[h].vid === +v) add(h, v, 1); else addVariant(v, 1); }
      });
    }
    function line(h, name, img, url, price, vid, avail) {
      return '<div class="cd-line"><a class="cd-img" href="' + esc(url) + '"><img src="' + esc(img) + '" alt=""></a><div class="cd-mid"><a class="cd-name" href="' + esc(url) + '">' + esc(name) + "</a>" +
        '<span class="cd-note">' + fmt(price) + '</span><div class="cd-qty"><button type="button" class="btn sm" data-wd-add="' + esc(h) + '" data-vid="' + vid + '"' + (avail ? "" : " disabled") + ">" +
        esc(avail ? L.addToCart : (R.soldOut || "")) + '</button><button type="button" class="cd-rm" data-wd-rm="' + esc(h) + '">' + esc(L.remove) + "</button></div></div></div>";
    }
    function renderW() {
      var box = q(".cd-lines", wd), hs = get();
      if (!hs.length) { box.innerHTML = '<p class="cd-empty">' + esc(R.wishEmpty || "") + "</p>"; return; }
      box.innerHTML = '<p class="cd-empty">' + esc(R.wishLoading || "") + "</p>";
      Promise.all(hs.map(function (h) {
        return fetch(ROOT + "products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (items) {
        var html = "";
        items.forEach(function (pj, i) {
          var h = hs[i], vp = VP[h]; if (!pj && !vp) return;
          var vs = pj ? (pj.variants || []) : [], v = vs.filter(function (x) { return x.available; })[0] || vs[0];
          if (vp && (!v || +v.id === +vp.vid)) html += line(h, vp.name, vp.img, vp.url, vp.price, vp.vid, vp.avail !== false && (!v || v.available));
          else if (pj && v) { var img = pj.featured_image ? (pj.featured_image.indexOf("//") === 0 ? "https:" + pj.featured_image : pj.featured_image) : ""; if (img) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=160";
            html += line(h, pj.title, img, ROOT + "products/" + h, v.price / 100, v.id, v.available); }
        });
        box.innerHTML = html || '<p class="cd-empty">' + esc(R.wishErr || "") + "</p>";
      });
    }
    function open() { if (!wd) build(); wd.hidden = false; document.documentElement.classList.add("lock"); renderW(); var x = q(".cd-x", wd); if (x) x.focus(); }
    function close() { if (wd) { wd.hidden = true; document.documentElement.classList.remove("lock"); } }
    document.addEventListener("click", function (e) {
      var heart = e.target.closest(".vorell-wish-heart,.vorell-wish-pdp");
      if (heart) { e.preventDefault(); e.stopPropagation(); toggle(heart.getAttribute("data-wish-handle")); return; }
      var op = e.target.closest(".vorell-wish-open"); if (op) { e.preventDefault(); open(); }
    });
    return { sync: sync, close: close, open: open, get: get };
  })();

  // ---------------- search overlay + predictive search (Shopify search/suggest.json, as the old header search) ----------------
  var srch = (function () {
    var ov, inp, out, t = 0, ctl;
    function build() {
      ov = el('<div class="v-srch" role="dialog" aria-modal="true" aria-label="' + esc(R.search || "") + '" hidden><div class="v-srch-scrim" data-srch-close></div><div class="v-srch-panel">' +
        '<form class="v-srch-f" action="' + ROOT + 'search" method="get" role="search"><input type="search" name="q" autocomplete="off" placeholder="' + esc(R.searchPh || "") + '" aria-label="' + esc(R.search || "") + '">' +
        '<input type="hidden" name="options[prefix]" value="last"><button type="submit" class="btn sm">' + esc(R.search || "") + '</button><button type="button" class="v-srch-x" data-srch-close aria-label="' + esc(L.close) + '">×</button></form>' +
        '<div class="v-srch-r" aria-live="polite"></div></div></div>');
      document.body.appendChild(ov); inp = q("input[name=q]", ov); out = q(".v-srch-r", ov);
      ov.addEventListener("click", function (e) { if (e.target.closest("[data-srch-close]")) close(); });
      inp.addEventListener("input", function () { clearTimeout(t); t = setTimeout(suggest, 220); });
    }
    function suggest() {
      var v = inp.value.trim(); if (!v) { out.innerHTML = ""; return; }
      if (ctl && ctl.abort) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
      var u = ROOT + "search/suggest.json?q=" + encodeURIComponent(v) + "&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last";
      fetch(u, { headers: { Accept: "application/json" }, signal: ctl ? ctl.signal : undefined }).then(function (r) { return r.json(); }).then(function (j) {
        var res = (j.resources && j.resources.results) || {}, h = "";
        var ps = res.products || [], as = res.articles || [], pg = res.pages || [];
        if (ps.length) h += "<div><h3>" + esc(R.sProducts) + "</h3>" + ps.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || "");
          return '<a class="v-srch-p" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + (img.indexOf("?") > -1 ? "&" : "?") + 'width=120" alt="" loading="lazy">' : "<span></span>") +
            "<b>" + esc(p.title) + "</b><span>" + (p.price != null ? fmt(+p.price) : "") + "</span></a>";
        }).join("") + "</div>";
        if (as.length) h += "<div><h3>" + esc(R.sArticles) + "</h3>" + as.map(function (a) { return '<a class="v-srch-l" href="' + esc(a.url) + '">' + esc(a.title) + "</a>"; }).join("") + "</div>";
        if (pg.length) h += "<div><h3>" + esc(R.sPages) + "</h3>" + pg.map(function (a) { return '<a class="v-srch-l" href="' + esc(a.url) + '">' + esc(a.title) + "</a>"; }).join("") + "</div>";
        h += h ? '<a class="link v-srch-all" href="' + ROOT + "search?q=" + encodeURIComponent(v) + '&options[prefix]=last">' + esc(R.searchAll) + "</a>" : '<p class="cd-empty">' + esc(R.searchNone) + "</p>";
        out.innerHTML = h;
      }).catch(function () {});
    }
    function open() { if (!ov) build(); ov.hidden = false; document.documentElement.classList.add("lock"); setTimeout(function () { inp.focus(); }, 30); }
    function close() { if (ov && !ov.hidden) { ov.hidden = true; document.documentElement.classList.remove("lock"); } }
    document.addEventListener("click", function (e) { var b = e.target.closest("[data-search-open]"); if (b) { e.preventDefault(); open(); } });
    return { open: open, close: close };
  })();

  // ---------------- /cart page: order note + shipping estimator (old snippets/shipping-estimator) ----------------
  function cartPageInit() {
    var nt = q("[data-cart-note]"); if (nt) nt.addEventListener("input", function () { saveNote(nt.value, null); });
    var est = q("[data-est]"); if (!est) return;
    var cs = q("[data-est-country]", est), ps = q("[data-est-province]", est), pw = q("[data-est-pwrap]", est), zip = q("[data-est-zip]", est), outE = q("[data-est-out]", est);
    var def = cs.getAttribute("data-default"); if (def) for (var i = 0; i < cs.options.length; i++) if (cs.options[i].value === def || cs.options[i].text === def) { cs.selectedIndex = i; break; }
    function provinces() {
      var o = cs.options[cs.selectedIndex], list = []; try { list = JSON.parse(o.getAttribute("data-provinces") || "[]"); } catch (e) {}
      ps.innerHTML = list.map(function (p) { return '<option value="' + esc(p[0]) + '">' + esc(p[1]) + "</option>"; }).join(""); pw.hidden = !list.length;
    }
    cs.addEventListener("change", provinces); provinces();
    q("[data-est-go]", est).addEventListener("click", function () {
      var b = this, qs = "shipping_address[zip]=" + encodeURIComponent(zip.value) + "&shipping_address[country]=" + encodeURIComponent(cs.value) + "&shipping_address[province]=" + encodeURIComponent(pw.hidden ? "" : ps.value);
      b.disabled = true; outE.hidden = true;
      function show(h) { outE.innerHTML = h; outE.hidden = false; b.disabled = false; }
      function poll(n) {
        return fetch(ROOT + "cart/async_shipping_rates.json?" + qs).then(function (r) { return r.text(); }).then(function (tx) {
          if (tx === "null" && n < 20) return new Promise(function (res) { setTimeout(res, 500); }).then(function () { return poll(n + 1); });
          return JSON.parse(tx);
        });
      }
      fetch(ROOT + "cart/prepare_shipping_rates.json?" + qs, { method: "POST" }).then(function (r) {
        if (r.ok) return poll(0).then(function (j) {
          var rates = (j && j.shipping_rates) || [];
          if (!rates.length) return show("<p>" + esc(R.estNone) + "</p>");
          show("<p>" + esc(rates.length === 1 ? R.estOne : R.estMany) + "</p><ul>" + rates.map(function (x) { return "<li>" + esc(x.presentment_name || x.name) + ": " + (+x.price ? fmt(+x.price) : L.free) + "</li>"; }).join("") + "</ul>");
        });
        return r.json().then(function (j) { show("<p>" + esc(R.estErr) + "</p><ul>" + Object.keys(j || {}).map(function (k) { return "<li>" + esc(k) + " " + esc([].concat(j[k]).join(", ")) + "</li>"; }).join("") + "</ul>"); });
      }).catch(function () { show("<p>" + esc(R.estErr) + "</p>"); });
    });
  }

  // ---------------- mobile menu drawer ----------------
  function menu() {
    var m = q(".md"); if (!m) return;
    qa("[data-md-open]").forEach(function (b) { b.addEventListener("click", function () { m.hidden = false; document.documentElement.classList.add("lock"); b.setAttribute("aria-expanded", "true"); }); });
    qa("[data-md-close]", m).forEach(function (b) { b.addEventListener("click", closeMenu); });
    qa("a", m).forEach(function (a) { a.addEventListener("click", closeMenu); });
  }
  // QA fix: aria-expanded goes back to "false" however the drawer closes (×, scrim, link, Escape)
  function closeMenu() {
    var m = q(".md"); if (m) m.hidden = true;
    document.documentElement.classList.remove("lock");
    qa("[data-md-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  }

  // ---------------- Glow Club (old snippets/vorell-popup.liquid data + native Shopify customer form) ----------------
  // Fields and tags as the old popup: email, phone (contact[phone]), birthday (Klaviyo queue only, as before), email opt-in
  // (contact[accepts_marketing] only when ticked, tag email-opt-in) and KVKK SMS opt-in (tag sms-opt-in); tags newsletter,glow-club,popup.
  // Opens after 9 s or on exit intent, once per browser (localStorage vorell_glowclub_pop). The Smile.io panel owns the "Glow Club"
  // name when Smile is on the page: [data-club-open] links open SmileUI, the v3 bubble is hidden by CSS.
  function club() {
    var b = el('<button type="button" class="v-club-bubble" aria-haspopup="dialog"><span>Glow<br>Club</span></button>');
    var m = el('<div class="v-club" role="dialog" aria-modal="true" aria-label="Glow Club" hidden><div class="v-club-card">' +
      '<button type="button" class="v-club-x" aria-label="' + L.close + '">×</button><p class="v-club-eyebrow">VORELL · GLOW CLUB</p>' +
      '<h2 class="v-club-h">' + L.clubH + '</h2><p class="v-club-p">' + L.clubP + '</p>' +
      '<form class="v-club-f vx"><input type="email" name="contact[email]" required autocomplete="email" placeholder="' + L.email + '" aria-label="' + L.email + '">' +
      '<input type="tel" name="phone" autocomplete="tel" inputmode="tel" placeholder="' + esc(R.phonePh || "") + '" aria-label="' + esc(R.phoneAria || "") + '">' +
      '<p class="v-club-bl">' + esc(R.bdayL || "") + '</p><input type="date" name="birthday" aria-label="' + esc(R.bdayAria || "") + '">' +
      '<label class="chk"><input type="checkbox" name="accepts_marketing" value="1" checked><span>' + esc(R.optEmail || "") + '</span></label>' +
      '<label class="chk"><input type="checkbox" name="sms_opt_in" value="1"><span>' + esc(R.optSms || "") + '</span></label>' +
      '<button type="submit">' + L.join + "</button></form>" +
      '<p class="v-club-fine">' + (R.clubFineHtml || L.clubFine) + "</p></div></div>");
    document.body.appendChild(b); document.body.appendChild(m);
    var KEY = "vorell_glowclub_pop";
    function open() { m.hidden = false; try { localStorage.setItem(KEY, "1"); } catch (e) {} }
    function close() { m.hidden = true; }
    // Smile "lite" defines SmileUI only after its SDK loads (on first launcher click); loadSmileSdk() loads it on demand.
    function smileReady() { return window.SmileUI && typeof window.SmileUI.openPanel === "function"; }
    function openSmile() {
      if (smileReady()) { try { window.SmileUI.openPanel(); return true; } catch (er) { return false; } }
      if (typeof window.loadSmileSdk !== "function") return false;
      try { window.loadSmileSdk(); } catch (er) { return false; }
      var t0 = Date.now();
      (function wait() {
        if (smileReady()) { try { window.SmileUI.openPanel(); } catch (er) { open(); } }
        else if (Date.now() - t0 > 8000) open();
        else setTimeout(wait, 150);
      })();
      return true;
    }
    b.addEventListener("click", open);
    qa("[data-club-open]").forEach(function (x) { x.addEventListener("click", function (e) { e.preventDefault(); if (!openSmile()) open(); }); });
    q(".v-club-x", m).addEventListener("click", close);
    m.addEventListener("click", function (e) { if (e.target === m) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    var f = q("form", m);
    function thanks() {
      q(".v-club-card", m).innerHTML = '<p class="v-club-eyebrow">VORELL · GLOW CLUB</p><h2 class="v-club-h">' + L.clubThanks + '</h2><p class="v-club-p">' + L.clubThanksP + "</p>";
      setTimeout(close, 6000);
    }
    function fail(btn) {
      var p = q(".v-club-err", m);
      if (!p) { p = el('<p class="v-club-fine v-club-err" role="alert"></p>'); f.parentNode.insertBefore(p, f.nextSibling); }
      p.textContent = L.clubErr || ""; btn.disabled = false;
    }
    // Go-live fix (1 Kas): Shopify only accepts customer-form POSTs carrying its bot-protection token, which its own script adds to
    // {% form 'customer' %} forms on submit (a fetch() POST got 400). The layout renders that native form hidden (#v3-club-native);
    // we copy the fields into it and submit it for real. Shopify returns to this page with ?customer_posted=true (or form errors).
    // Shopify's inline captcha script blocks a customer-form submit until hCaptcha is bound to that form (it binds on focusin/change
    // inside the form, or via Shopify.captcha.protect). Bind the hidden form as soon as the visitor touches the club form.
    function nativeForm() { return document.getElementById("v3-club-native"); }
    function bound(nf) { return !!(nf && (nf.dataset.hcaptchaBound || nf.dataset.recaptchaBound)); }
    function bind() {
      var nf = nativeForm(); if (!nf || nf.dataset.cptcha || bound(nf)) return;
      try { nf.elements["contact[email]"].dispatchEvent(new Event("focusin", { bubbles: true })); } catch (x) {}
    }
    f.addEventListener("focusin", bind);
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = q("button[type=submit]", f); if (btn.disabled) return;
      var nf = nativeForm(), email = f.elements["contact[email]"].value.trim();
      if (!nf || !email) { fail(btn); return; }
      btn.disabled = true;
      var phone = (f.elements.phone.value || "").trim(), am = f.elements.accepts_marketing.checked, sms = f.elements.sms_opt_in.checked;
      var tags = ["newsletter", "glow-club", "popup"]; if (sms) tags.push("sms-opt-in"); if (am) tags.push("email-opt-in");
      nf.elements["contact[email]"].value = email;
      nf.elements["contact[tags]"].value = tags.join(",");
      var amI = nf.querySelector("[data-club-am]"), phI = nf.querySelector("[data-club-phone]");
      if (amI) amI.disabled = !am;
      if (phI) { phI.value = phone; phI.disabled = !phone; }
      // Klaviyo identify/track exactly as the old popup pushed them (the queue is only read if the Klaviyo onsite embed is ever enabled)
      try {
        window._learnq = window._learnq || [];
        var payload = { "$email": email, "Glow Club": true, "Source": "exit-popup" };
        if (phone) payload["$phone_number"] = phone;
        var bday = (f.elements.birthday && f.elements.birthday.value) || ""; if (bday) payload.Birthday = bday;
        if (sms) payload["SMS Consent"] = "true";
        window._learnq.push(["identify", payload]);
        window._learnq.push(["track", "Glow Club Joined", { source: "exit-popup", code: "VORELL10" }]);
      } catch (er) {}
      try { sessionStorage.setItem("vclubpost", "1"); } catch (x) {}
      bind();
      var t0 = Date.now();
      (function go() {
        // no captcha on the store (no Shopify.captcha) -> plain native submit; otherwise wait (max 8 s) for hCaptcha to bind
        if (bound(nf) || !(window.Shopify && Shopify.captcha) || Date.now() - t0 > 8000) {
          if (nf.requestSubmit) nf.requestSubmit(); else HTMLFormElement.prototype.submit.call(nf);
          setTimeout(function () { btn.disabled = false; }, 15000);   // the visitor closed a Shopify challenge
        } else setTimeout(go, 150);
      })();
    });
    var posted = false; try { posted = sessionStorage.getItem("vclubpost") === "1"; } catch (x) {}
    if (posted) {
      var okM = q("[data-club-ok]"), errM = q("[data-club-err]");
      if (okM || errM || /[?&]customer_posted=true/.test(location.search)) { try { sessionStorage.removeItem("vclubpost"); } catch (x) {} }
      if (okM || (/[?&]customer_posted=true/.test(location.search) && !errM)) { open(); thanks(); }
      else if (errM) {
        // an address that is already a customer is still a member: treat "taken" as success
        if (/taken|already|exist|alınmış|zaten|kullanıl/i.test(errM.getAttribute("data-club-err") || "")) { open(); thanks(); }
        else { open(); fail(q("button[type=submit]", f)); }
      }
    }
    function reveal() { b.classList.toggle("show", !document.body.classList.contains("no-bubble") && (params.has("club") || window.scrollY > window.innerHeight * 0.8)); }
    window.addEventListener("scroll", reveal, { passive: true }); reveal();
    if (params.has("club")) { open(); return; }
    var seen = false; try { seen = !!localStorage.getItem(KEY); } catch (e) {}
    if (seen || posted || params.has("noclub") || params.has("still")) return;
    var shown = false, tm = setTimeout(show, 9000);
    function show() { if (shown || !m.hidden) return; shown = true; open(); }
    document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(tm); show(); } });
  }

  // ---------------- wholesale price-list request (native Shopify contact form) ----------------
  function wsForm() {
    var f = q("[data-ws-form]") || q("form.ws-form"); if (!f) return;
    f.noValidate = true;
    var msg = q(".ws-msg", f), btn = q("button[type=submit]", f);
    function F(n) { return f.elements[n]; }
    qa("[data-doc-request]").forEach(function (a) {
      a.addEventListener("click", function () {
        var t = F("contact[body]"), head = a.closest(".ws-doc").querySelector("b");
        if (t && head && !t.value) t.value = head.textContent + ": ";
      });
    });
    f.addEventListener("submit", function (e) {
      qa(".bad", f).forEach(function (x) { x.classList.remove("bad"); });
      var bad = [];
      ["contact[Firma]", "contact[name]", "contact[IsModeli]"].forEach(function (k) { if (F(k) && !F(k).value.trim()) bad.push(F(k).closest(".fld")); });
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(F("contact[email]").value.trim())) bad.push(F("contact[email]").closest(".fld"));
      if (!F("contact[KVKK]").checked) bad.push(F("contact[KVKK]").closest(".chk"));
      if (bad.length) { e.preventDefault(); bad.forEach(function (x) { x.classList.add("bad"); }); msg.className = "ws-msg err"; msg.textContent = VW.fReq; var i = bad[0].querySelector("input,select"); if (i) i.focus(); return; }
      if (F("website") && F("website").value) { e.preventDefault(); f.reset(); msg.className = "ws-msg ok"; msg.textContent = VW.fOk; return; }   // honeypot
      btn.disabled = true; btn.textContent = VW.fSending; msg.className = "ws-msg"; msg.textContent = "";
      // Shopify may show an hCaptcha challenge before the native POST; if the visitor closes it, give the button back
      setTimeout(function () { btn.disabled = false; btn.textContent = VW.fSubmit; }, 15000);
      // no preventDefault: the native POST goes to Shopify /contact and returns with ?contact_posted=true#ws-form
    });
    if (/[?&]contact_posted=true/.test(location.search) || q(".ws-msg.ok", f)) {
      var sec = q("#form"); if (sec && sec.scrollIntoView) setTimeout(function () { sec.scrollIntoView(); }, 50);
    }
  }

  function ctool() {
    var f = q("[data-ctool]"); if (!f) return;
    f.addEventListener("change", function () { if (f.requestSubmit) f.requestSubmit(); else f.submit(); });
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); closeMenu(); wish.close(); srch.close(); } });
  document.addEventListener("DOMContentLoaded", function () {
    buildDrawer(); render(); hero(); pdp(); quick(); menu(); club(); wsForm(); soldOutCards(document); wish.sync(); cartPageInit(); ctool();
    if (params.has("cart")) openCart();
    refresh().catch(function () {});
  });
  window.addEventListener("pageshow", function (e) { if (e.persisted) refresh().catch(function () {}); });
  window.VORELL = { fmt: fmt, offFor: offFor, calc: calc, add: add, MB: MB, cart: function () { return cart; }, refresh: refresh, wish: wish, search: srch,
                    clear: function () { return api("cart/clear.js", {}).then(function (c) { cart = c; render(); }); } };
})();
